// @flow
import React, { Component } from 'react';

import Sidebar from 'components/sidebar/Sidebar';
import ClubPractices from 'components/club/ClubPractices';
import ContentBloc from 'components/newsletter/blocs/ContentBloc';

import type { BlocContent } from 'types/NewsletterBloc';
import type { Pratique } from 'types/Club';

type Props = {
  contentNode: BlocContent[],
  sidebar_content: BlocContent[],
  pratiques_structure: Pratique[],
};

type State = {
  practiceType: string[],
  practicesAudience: string[],
}

class PageEntrainements extends Component<Props, State> {
  state = {
    practicesAudience: [],
    practiceType: [],
  };


  renderSidebar = () => {
    const { sidebar_content } = this.props;
    return <Sidebar sidebarContent={sidebar_content} />;
  };

  render() {
    const { pratiques_structure, contentNode } = this.props;
    return (
      <div className="row">
        <div className="col col-md-8 col-lg-9 bg-overflow">
          <section>
            <div className="row">
              <div className="col col-lg-8on9">
                <div className="page">
                  {contentNode.map((blocFigure, index) => {
                    return (
                      <ContentBloc key={index} {...blocFigure} />
                    );
                  })}
                  {pratiques_structure && 
                  <ClubPractices practices={pratiques_structure} />}
                </div>
              </div>
            </div>
          </section>
        </div>
        {this.renderSidebar()}
      </div>
    );
  }
}

export default PageEntrainements;
